import React, { useState } from "react";
import { createPortal } from 'react-dom';
import * as S from './BookingDetailsStyles'
import Terminals from "../Terminals/Terminals";
import OwnerDetails from "../OwnerDetails/OwnerDetails";
import Button from "../Button/Button";
import { pushCtaOmniEvents } from "../../../../../config/omni";
import { CTA_TYPE } from "../../../../../utils/omni-utils";
import { CABS_HOB_THANK_YOU_ROUTE, CALL_DRIVER_CLICKED, CALL_DRIVER_CTA_CLICKED, CALL_HELPLINE_CLICKED, CALL_HELPLINE_CTA_CLICKED, HOB_THANK_YOU_PAGE, KIOSK_IMAGE_CLICKED, KIOSK_MAP_CLICKED, KIOSK_MAP_CLICKED_MMT, KIOS_IMAGE_CLICKED, MOB_CABS_HOB_THANK_YOU } from "../../../../../utils/util-constants";
import { trackEvent, PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU } from "../../../../../config/omniMmt";

const BookingDetails = ({
    data,
    driverNumber = '',
    helplineNumber = '',
    rightImg =''
}) => { 
    const [fullImgView, setFullImgView] = useState(false)
    const {
        otpTxt,
        ownerDetails,
        facilities,
        vehicleImg,
        vehicleNo,
        helplineNumberTxt,
        driverNumberTxt,
        guideSectionData,
        footerData,
        kioskMapUrl
    } = data || {};

    const otpSection = () => (
      <S.OtpSection>
        {otpTxt?.label1}
        {otpTxt?.value &&  (
          <S.Otp>
            {otpTxt?.value?.split('').map((digit, index) => (
              <S.OtpSpan key={index}>{digit}</S.OtpSpan>
            ))}
          </S.Otp>
        )}
          {otpTxt?.label2}
      </S.OtpSection>
    )

    const headerSection = () => (
      <S.HeaderSection>
        <S.HeaderTopSection>
          <div>
            {vehicleNo && <S.VehicleNo>{vehicleNo}</S.VehicleNo>}
            {ownerDetails && <OwnerDetails data={ownerDetails} />}
            {facilities && <S.Facilities>
              {facilities?.map((item, idx) => (
                <S.Facility>
                  {item?.img && <img src={item?.img}/>}
                  {item?.label}
                </S.Facility>
              ))}
            </S.Facilities>}
          </div>
            <S.VehicleImgView>
                {rightImg && 
                <S.VehicleLogoWrap>
                  <S.VehicleLogo src={rightImg} />
                </S.VehicleLogoWrap>}
                {vehicleImg && <S.VehicleImg src={vehicleImg} />}
            </S.VehicleImgView>
        </S.HeaderTopSection>
          {(driverNumber || helplineNumber) && <S.BtnsWpr>
              {helplineNumber && <Button btnTxt={helplineNumberTxt} type={2} onClick={() => {
                pushCtaOmniEvents(`${MOB_CABS_HOB_THANK_YOU}_${CALL_HELPLINE_CLICKED}`, CTA_TYPE.BUTTON, HOB_THANK_YOU_PAGE, CABS_HOB_THANK_YOU_ROUTE)
              }} number ={helplineNumber} isCall={true}/>}
              {driverNumber && <Button btnTxt={driverNumberTxt} type={1} onClick={() => {
                pushCtaOmniEvents(`${MOB_CABS_HOB_THANK_YOU}_${CALL_DRIVER_CLICKED}`, CTA_TYPE.BUTTON, HOB_THANK_YOU_PAGE, CABS_HOB_THANK_YOU_ROUTE)
              }} number = {driverNumber} isCall={true}/>}
          </S.BtnsWpr>}
      </S.HeaderSection>
    );

    const guideSection = () => (
      <S.GuideSection>
        {guideSectionData?.label && <S.Label>{guideSectionData?.label}</S.Label>}
        {guideSectionData?.subLabel?.map((label, index) => (
          <S.SubLabel key={index}>
            <span>{index + 1}.</span>
            {label}
          </S.SubLabel>
        ))}
        {guideSectionData?.listItems && <S.ListItems>
          {guideSectionData?.listItems?.map((item, idx) => (
            <S.ListItem key={item?.id} onClick={() => {
              if (item?.type === "map") {
                pushCtaOmniEvents(`${MOB_CABS_HOB_THANK_YOU}_${KIOSK_MAP_CLICKED}`, CTA_TYPE.BUTTON, HOB_THANK_YOU_PAGE, CABS_HOB_THANK_YOU_ROUTE)
     
                  Boolean(kioskMapUrl) && typeof window !== "undefined" ? window.open(kioskMapUrl, '_blank') : setFullImgView(item?.img);
              } else {
                pushCtaOmniEvents(`${MOB_CABS_HOB_THANK_YOU}_${KIOS_IMAGE_CLICKED}`, CTA_TYPE.BUTTON, HOB_THANK_YOU_PAGE, CABS_HOB_THANK_YOU_ROUTE)
         
                setFullImgView(item?.img);
              }}} className={guideSectionData.listItems.length === 1 ? 'singleItem' : ''}>
              <img src={item?.img} alt={item?.label} className={guideSectionData.listItems.length === 1 ? 'singleItem' : ''}/>
              {item?.label && <span className="label">{item?.label}</span>}
            </S.ListItem>
          ))}
        </S.ListItems>}
      </S.GuideSection>
    );

  const imageView = () => {
    return (
      <div>
        {createPortal(
          <S.PBFullImageView>
            <S.ImageCrossIc onClick={()=>setFullImgView(false)}/>
            <div className="kiosk-image-view">
              <S.KioskImage src={fullImgView} />
            </div>
          </S.PBFullImageView>,
          document.body
        )}
      </div>
    )
  };

  return (
    <div className="bookingDetails">
      {fullImgView && imageView()}
      {otpSection()}
      <S.WhiteBox>
        {headerSection()}
        {guideSectionData && guideSection()}
        <Terminals data={footerData} />
      </S.WhiteBox>
    </div>
  );
};

export default BookingDetails;